var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('stripe-elements',{ref:"elementsRef",attrs:{"pk":_vm.stripePublishableKey,"amount":0,"locale":"en"},on:{"token":_vm.tokenCreated,"loading":function($event){_vm.loading = $event}}}),_c('vs-button',{staticClass:"mb-2",on:{"click":_vm.submit}},[_vm._v("Save Card Details")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }